import { createContext, useContext } from 'react';

export const MacrosContext = createContext({
  macros: undefined,
  modalOpen: false,
  activeMacro: null,
  activeMacroType: null,
  deleteMacroId: null,
  filters: {},
  isGettingMacros: false,
  isDeletingMacros: false,
  customCN: null,

  setModalOpen: () => {},
  deleteMacro: () => {},
  setActiveMacro: () => {},
  setActiveMacroType: () => {},
  setDeleteMacroId: () => {},
  setFilters: () => {},
  setCustomCN: () => {}
});

export const useMacrosContext = () => useContext(MacrosContext);
